export function OpenBurger() {

    const $burger = {
        btn: $('.c-burger'),
        bar: {
            top: $('.c-burger span:nth-child(1)'),
            middle: $('.c-burger span:nth-child(2)'),
            bottom: $('.c-burger span:nth-child(3)'),
        },
        class: 'js-isActive'
    }

    TweenMax.fromTo($burger.bar.middle, .3, {scaleX: .6, ease: Power3.easeInOut}, {scaleX: 0, ease: Power3.easeInOut});
    TweenMax.fromTo($burger.bar.top, .3, {rotation: 0, y: '0px', ease: Power3.easeInOut, delay: .2}, {rotation: 0, y: '9px', ease: Power3.easeInOut, delay: .2});
    TweenMax.fromTo($burger.bar.bottom, .3, {rotation: 0, y: '0px', ease: Power3.easeInOut, delay: .2}, {rotation: 0, y: '-9px', ease: Power3.easeInOut, delay: .2});
    TweenMax.fromTo($burger.bar.top, .3, {rotation: '0deg', ease: Power3.easeInOut}, {rotation: '45deg', ease: Power3.easeInOut, delay: .5});
    TweenMax.fromTo($burger.bar.bottom, .3, {rotation: '0deg', ease: Power3.easeInOut}, {rotation: '-45deg', ease: Power3.easeInOut, delay: .5});
}


export function CloseBurger() {

    const $burger = {
        btn: $('.c-burger'),
        bar: {
            top: $('.c-burger span:nth-child(1)'),
            middle: $('.c-burger span:nth-child(2)'),
            bottom: $('.c-burger span:nth-child(3)'),
        },
        class: 'js-isActive'
    }

    TweenMax.fromTo($burger.bar.middle, .3, {scaleX: 0, ease: Power3.easeInOut}, {scaleX: 1, ease: Power3.easeInOut, delay: .5});
    TweenMax.fromTo($burger.bar.top, .3, {rotation: 0, y: '9px', ease: Power3.easeInOut, delay: .2}, {rotation: 0, y: '0', ease: Power3.easeInOut, delay: .2});
    TweenMax.fromTo($burger.bar.bottom, .3, {rotation: 0, y: '-9px', ease: Power3.easeInOut, delay: .2}, {rotation: 0, y: '0px', ease: Power3.easeInOut, delay: .2});
    TweenMax.fromTo($burger.bar.top, .3, {rotation: '45deg', ease: Power3.easeInOut}, {rotation: '0deg', ease: Power3.easeInOut});
    TweenMax.fromTo($burger.bar.bottom, .3, {rotation: '-45deg', ease: Power3.easeInOut}, {rotation: '0deg', ease: Power3.easeInOut});
}
